import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

/**
 * Wrap children to fade-up when scrolled into view.
 * Honors prefers-reduced-motion.
 */
export default function Reveal({ children, delay = 0, y = 16, className = '', once = true, amount = 0.2 }) {
  const reduce = useReducedMotion();
  if (reduce) return <div className={className}>{children}</div>;
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount }}
      transition={{ duration: 0.65, ease: [0.16, 1, 0.3, 1], delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
